import locationType from '../../../../types/functions/Location/LocationType';
import ReportLogicLocation from '../../../../types/functions/Location/ReportLogicLocation';
import Statement from '../../../types/Functions/Statement';

const getEmptyLocation = (): ReportLogicLocation => {

    return {} as ReportLogicLocation;
};

const isRoot = (location: ReportLogicLocation): boolean => {

    return location.argumentIndexes.length === 0;
}

const createLocation = (number: number, name: string): ReportLogicLocation => {

    let loc: ReportLogicLocation = reportLogicLocationHelper.getEmptyLocation();
    loc.statementNumber = number;

    let statementToLower = name.toLowerCase();

    switch (statementToLower) {
        case locationType.statement.lookup: loc.statement = locationType.statement.lookup; break;
        case locationType.statement.variable: loc.statement = locationType.statement.variable; break;
        case locationType.statement.validation: loc.statement = locationType.statement.validation; break;

        default: break;
    }

    return loc;
}

const reportLogicLocationHelper = {
    getEmptyLocation,
    isRoot,
    createLocation
};

export default reportLogicLocationHelper;
